import React, { useCallback, useContext, useEffect, useState } from "react";
import moengage from "@moengage/web-sdk";
// import { useHistory } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../shared/context/UserContext";
// import LabeledInputGroup from '../../../components/advance/LabeledInputGroup';
// import Loading from '../../../components/advance/Loading';
// import Modal from '../../../components/advance/Modal';
import Modal from "../../components/advance/Modal";
// import Button from '../../../components/core/Button';
import Button from "../../components/core/EPL_Button_Think";
// import Label from '../../../components/core/Label';
import useMediaQuery from "../../hooks/useMediaQuery";
// import AutoDebitFailModal from '../../../modals/AutoDebitFailModal';
// import AutoDebitModal from '../../../modals/AutoDebitModal';
// import AutoDebitSuccessModal from '../../../modals/AutoDebitSuccessModal';
// import BankNotListedModal from '../../../modals/BankNotListedModal';.
// import EmandateCompletionTimeModal from '../../../modals/EmandateCompletionTimeModal';
import EmandateIframeModal from "../../modals/EmandateIframeModal";
// import EmandateRegistrationTimeModal from '../../../modals/EmandateRegistrationTimeModal';
// import ImpsInitModal from '../../../modals/ImpsInitModal';
// import { UserContext } from '../../../shared/context/UserContext';
// import useMediaQuery from '../../../shared/hooks/useMediaQuery';
// import VendorService from '../../../shared/services/VendorService';
// import poll from '../../../shared/utils/poll';
// import sendRequest from '../../../shared/utils/sendRequest';
import {
  filterBankAccountNumber,
  isValidBankAccountNumber,
} from "../../shared/validations/BankAccountNumber";
// import { isValidBankBranch } from '../../../shared/validations/BankBranch';
// import { isValidBankIfscNumber } from '../../../shared/validations/BankIfscNumber';
// import { isValidBankName } from '../../../shared/validations/BankName';
// import Progress from '../../progress/Progress';
// import Summary from '../../summary/Summary';
// import { AfterLoginLayoutWrapper } from '../../_styles/AfterLoginLayoutWrapper';
import FloatingInput from "../../components/base/FloatingInput";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import { encrypt } from "../../utils/crypto";
import sendRequest from "../../utils/sendRequest";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import { BankDetailsWrapper } from "./_styles/BankDetailsWrapper";
// import bankDetailsArt from "../../assets/images/EPL_think_images/Bank_Details_Art.png";
import { CSSTransition } from "react-transition-group";
import { GetCustomerDetailsContext, validateInputExistenece } from "../../App";
import {
  EMANDATE,
  EMANDATE_POLLING,
  GET_BRANCH,
  INSERT_BANK_DETAILS,
  PENNY_DROP,
  DS_NAME_MATCH,
} from "../../Config";
import bankDetailsTitleIcon from "../../assets/svg/EPL_think_svg/Bank_Details_Title_Icon.svg";
import { updateLead } from "../../shared/services/crm";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { isValidIfsc } from "../../shared/validations/IFSC";
import { isValidName } from "../../shared/validations/Name";
import poll from "../../utils/poll";
import {
  EmandateFailedModal,
  BankDetailsIncorrect,
  EmandateRetryModal,
  CheckInternetModal,
  EmandateVerificationPendingModal,
  RejectNameMatchModal,
  PennyDropModal,
  BankUdyamMismatchModal
} from "../other-pages/Modals/AllModal";
import ScenarioBasedModal from "../other-pages/Modals/ScenarioBasedModal";
import CheckField from "../../components/form/CheckField";
import { isStageLogin } from "../../shared/validations/StageLogin";
import isEnglish from "../../shared/validations/isEnglish";
import { userConsentStatus } from "../../utils/userConsentStatus";
import { encryptedData } from "../../utils";
moengage.initialize({ app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL", cluster: "dc_3" });

const getStage = (stage, status) => {
  switch (stage) {
    case "BANK_DETAILS": {
      return "EDITING";
    }
    case "IMPS": {
      if (status === "INIT") return "IMPSINIT";
      else return "IMPSCHECK";
    }
    case "EMANDATE": {
      if (status === "INIT") return "EMANDATEINIT";
      if (status === "AUTHORIZATION") return "EMANDATEAUTHORIZATION";
      if (status === "BANKDELAY") return "EMANDATEBANKDELAY";
      if (status === "PENDING") return "EMANDATEPENDING";
      if (status === "INCOMPLETE") return "EMANDATEINCOMPLETE";
      if (status === "COMPLETE") return "EMANDATESUCCESS";
      else return "EMANDATEINCOMPLETE";
    }
    default:
      return "EDITING";
  }
};

const BankDetails = () => {
  // const history = useHistory();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  const { user, setUser } = useContext(UserContext);
  const [dataCaptured, setDataCaptured] = useState();
  const [buttonDisabledFlag, setButtonDisabledFlag] = useState(false);
  // const applicationFormNumber = user.application_form_no;
  // // const cccId = user.ccc_id;
  // const name = user.name;
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  // );
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [showShimmer, setShowShimmer] = useState(false);
  const [maxRetryReached, setMaxRetryReached] = useState(false);
  const [emandateRetry, setEmandateRetry] = useState(false);
  const [bankDetailsWrong, setBankDetailsWrong] = useState(false);
  const [emandateIframeModalFlag, setEmandateIframeModalFlag] = useState(false);
  const [showRejectNameMatchModal, setShowRejectNameMatchModal] =
    useState(false);
  // setShowShimmer(false);
  const [pennyDropFailed, setPennyDropFailed] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  useEffect(() => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("AdditionalDetails customerDetails: ", customerDetails);
      setShowShimmer(false);
      // TODO: Handle Staging if needed

      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
        state: {
          customerDetails: customerDetails,
        },
      });
    } else {
      // console.log("AdditionalDetails Ouch customerDetails ", location);
    }
  }, [customerDetails]);

  const source = location.pathname.split("/")[1];

  useEffect(async () => {
    // console.log("JAINAM: ", customerDetails.stage);

    isStageLogin( 
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );
    if (customerDetails.stage === "EMANDATE_INCOMPLETE") {
      checkEmandateStatusApiOnLoad();
    } else if (customerDetails.stage === "EMANDATE_START") {
      setShowSetUpMandate(true);
    }
    setShowShimmer(true);
  }, []);

  useEffect(async () => {
    // window.scrollTo(0, 0);
    if (customerDetails.source === "upsell") {
      setAccountNumber(
        customerDetails.Data.account_number === "None"
          ? ""
          : customerDetails.Data.account_number
      );
      setAccountConfirmNumber(
        customerDetails.Data.account_number === "None"
          ? ""
          : customerDetails.Data.account_number
      );
    }

    if (
      customerDetails.Data.journey_type !== "preapproved" &&
      customerDetails.source === "epl"
    ) {
      setBank(
        customerDetails.Data.bank_name === "None"
          ? ""
          : customerDetails.Data.bank_name
      );
      setIfsc(
        customerDetails.Data.ifsc_code === "None"
          ? ""
          : customerDetails.Data.ifsc_code
      );
      if (isValidIfsc(customerDetails.Data.ifsc_code)) {
        await ifsc_master(customerDetails.Data.ifsc_code);
      }
    }

    if (customerDetails.Data.journey_type !== "preapproved") {
      // setBank(
      //   customerDetails.Data.bank_name === "None"
      //     ? ""
      //     : customerDetails.Data.bank_name
      // );
      setIfsc(
        customerDetails.Data.ifsc_code === "None"
          ? ""
          : customerDetails.Data.ifsc_code
      );
      if (isValidIfsc(customerDetails.Data.ifsc_code)) {
        await ifsc_master(customerDetails.Data.ifsc_code);
      }
    }
    // setBranch(customerDetails.Data.lms_branch_number)
    setShowShimmer(false);
  }, [customerDetails]);

  const [internetCheck, setInternetCheck] = useState(false);
  const [accountConfirmNumber, setAccountConfirmNumber] = useState("");
  const [accountConfirmNumberError, setAccountConfirmNumberError] =
    useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountNumberError, setAccountNumberError] = useState("");
  const [bank, setBank] = useState();
  const [bankNameError, setBankNameError] = useState(false);
  const [bankIBLRefNo, setBankIBLRefNo] = useState(user.bank_ibl_ref_no || "");
  const [branch, setBranch] = useState();
  const [branchNameError, setBranchNameError] = useState(false);
  const [emandateDelayBanksApiCalled, setEmandateDelayBanksApiCalled] =
    useState(false);
  const [emandateDelayBanks, setEmandateDelayBanks] = useState([]);
  const [emandateNoteModal, setEmandateNoteModal] = useState(false);
  const [emandateProcessID, setEmandateProcessID] = useState(
    user.mandate_id || ""
  );
  const [emandateShowCloseButton, setEmandateShowCloseButton] = useState(true);
  const [emandateURL, setEmandateURL] = useState(user.emandate_url || "");
  const [ifsc, setIfsc] = useState();
  const [ifscError, setIfscError] = useState(false);
  const [iFrameUrl, setIFrameUrl] = useState("");
  const [iFrameDisplay, setIFrameDisplay] = useState("none");
  const [showIframe, setShowIframe] = useState();
  const [showSetUpMandate, setShowSetUpMandate] = useState();
  const [razorpayVerficationPendingModal, setRazorpayVerficationPendingModal] =
    useState(false);
  const [modal, setModal] = useState("");
  const [emandate, setEmandate] = useState({
    // process_id: user.mandate_id,
    url: user.emandate_url,
    showIframeCloseButton: false,
  });

  let currentPageStage = "BANK_START";
  const [loading, setLoading] = useState(false);
  // const [mainState, setMainState] = useState(getStage(user.Stage.stage, user.Stage.stage_status));
  // const [state, setState] = useState(getStage(user.Stage.stage, user.Stage.stage_status));
  const [onSubmitButtonDisabled, setOnSubmitButtonDisabled] = useState(false);
  const [consentCheckbox, setConsentCheckbox] = useState(false);
  const [bankUdyamMismatchModal, setBankUdyamMismatchModal] = useState(false);
  const [bankAccVerificationConsent, setBankAccVerificationConsent] = useState(false)

  const updateConsentCheckbox = () => {
    setBankAccVerificationConsent(!bankAccVerificationConsent)
    setConsentCheckbox(!consentCheckbox);
  };

  const ifsc_master = async (ifscNumber) => {
    try {
      const { response } = await sendRequest(
        "/" + customerDetails.source + GET_BRANCH,
        {
          ifsc_code: ifscNumber,
        }
      );
      // console.log(response);
      if (response.Success) {
        setIfscError(false);
        if (
          customerDetails.Data.journey_type === "preapproved" ||
          customerDetails.source === "upsell"
        ) {
          setBank(response.bank_name);
        }
        if (
          customerDetails?.Data.accountNumber === undefined ||
          customerDetails?.Data.accountNumber === "" ||
          customerDetails?.Data.accountNumber === null
        ) {
          setBank(response.bank_name);
        }
        setBranch(response.branch);
      } else {
        setIfscError(true);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          71,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          71,
          customerDetails.application_form_number
        );
      }
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
      }

      setShowShimmer(false);
      /* Handle unexpected response */
    }
  };

  const updateIfsc = async (e) => {
    const ifscNumber = e.target.value.toUpperCase();
    setIfsc(ifscNumber);
    setIfscError(!isValidIfsc(ifscNumber));
    if (!isValidIfsc(ifscNumber)) {
      setBranch();
      if (
        customerDetails.Data.journey_type === "preapproved" ||
        customerDetails.source === "upsell"
      ) {
        setBank();
      }
    } else {
      await ifsc_master(ifscNumber);
    }
  };

  const updateAccountNumber = (e) => {
    const account_number = e.target.value;
    const filtered_account_number = filterBankAccountNumber(account_number);
    setAccountNumber(filtered_account_number);
  };

  const validateAccountNumber = () => {
    if (!isValidBankAccountNumber(accountNumber)) {
      setAccountNumberError("NOTVALID");
    }
  };

  const updateAccountConfirmNumber = (e) => {
    const account_number_confirm = e.target.value;
    const filtered_account_number_confirm = filterBankAccountNumber(
      account_number_confirm
    );
    setAccountConfirmNumber(filtered_account_number_confirm);
  };

  const validateAccountConfirmNumber = () => {
    if (!isValidBankAccountNumber(accountConfirmNumber)) {
      setAccountConfirmNumberError("NOTVALID");
    }
    if (!matchBankAccountNumber()) {
      setAccountConfirmNumberError("NOTSAME");
    }
  };

  const matchBankAccountNumber = useCallback(() => {
    return accountNumber === accountConfirmNumber;
  }, [accountConfirmNumber, accountNumber]);

  const checkBank = async () => {
    try {
      if (emandateDelayBanks.includes(bank)) {
        // setState('EMANDATENOTE');
        setEmandateNoteModal(true);
        setEmandateShowCloseButton(true);
      } else {
        // callEmandate();
      }
    } catch (error) {
      console.error(error);
      // setState('TECHNICAL');
    }
  };
  const [openEmandateIframe, setOpenEmandateIframe] = useState(false);

  const allFieldsValidated = () => {
    // console.log(
    //   isValidName(bank) > 0,
    //   isValidBankAccountNumber(accountNumber),
    //   isValidBankAccountNumber(accountConfirmNumber),
    //   isValidIfsc(ifsc)
    // );
    return (
      isValidName(bank) > 0 &&
      !bankNameError &&
      isValidName(branch) > 0 &&
      isValidBankAccountNumber(accountNumber) &&
      isValidBankAccountNumber(accountConfirmNumber) &&
      isValidIfsc(ifsc) &&
      consentCheckbox &&
      accountNumber === accountConfirmNumber &&
      !ifscError
    );
  };

  const handleOnCloseEmandateIframeModal = () => {
    // console.log("INSIDE HANDLEONSUBMIT");
    // var route = getRouteFromLoanStageService({
    //   source: customerDetails.source,
    //   // stage: customerDetails.stage,
    //   stage: "REFERENCE_START",
    // });
    // // console.log("stage: ", customerDetails.stage);
    // // console.log("route: ", route);
    // navigate(`${route}`, {
    //   replace: true,
    //   state: {
    //     customerDetails: customerDetails,
    //   },
    // });
  };

  const callEmandateApi = async (param) => {
    try {
      const { response } = await sendRequest(
        "/" + customerDetails.source + EMANDATE,
        {
          source: customerDetails.source,
          version: "2.0",
          upi_eligible : param === "upi" ? true: false,
          current_stage: "EMANDATE_START",
        }
      );
      // console.log(response, response.Data.url);
      // setCustomerDetails({
      //   ...customerDetails,
      //   stage: response.STAGE,
      // });
      if (response.Success) {
        setEmandateRetry(false);
        setShowSetUpMandate(false);
        setEmandateIframeModalFlag(true);
        /* Successful Response Action */
        setUser({
          ...user,
          emandate_process_id: response.Data.process_id,
          emandate_url: response.Data.url,
        });
        setEmandate({
          ...emandate,
          process_id: response.Data.process_id,
          url: response.Data.url,
        });
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            58,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            58,
            customerDetails.application_form_number
          );
        }
        setModal("EMANDATE_IFRAME");
        /* CRM Stage - E-Mandate Initiation */
        /*
        If isMandateDelayBank()
        CRM Stage - E-Mandate T+1 Initiation
        */
        /* Failed Response Action */
        setOnSubmitButtonDisabled(true);
        checkEmandateStatusApi();
      } else {
        setShowSetUpMandate(false);
        if (response.Message === "SUCCESS_REJECTED") {
          setShowSetUpMandate(false);
          setMaxRetryReached(true);
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              80,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              80,
              customerDetails.application_form_number
            );
          }
        }
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          71,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          71,
          customerDetails.application_form_number
        );
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      setShowShimmer(false);
      /* Handle unexpected response */
      if (error.code === "ECONNABORTED") {
        //rejection scene
      } else {
        /* CRM Stage - E-Mandate Check Technical Failure */
        // updateLeadApi({ crmId: 47 });
      }
    }
  };

  const pennyDropApi = async () => {
    setShowShimmer(true);
    try {
      const { response } = await sendRequest(
        "/" + customerDetails.source + PENNY_DROP,
        {
        }
      );
      if (response.Success) {
        // console.log("pennyDrop Success");
        // setShowSetUpMandate(true);
        await dsNameMatch();
        moengage.track_event("bank_verification_penny_drop", {
          journey_name: customerDetails.source,
          is_pennydrop_done: "yes",
        });
      } else {
        currentPageStage = response.STAGE;
        setResponseMessage(response.Message);
        setPennyDropFailed(true);
        moengage.track_event("bank_verification_penny_drop", {
          journey_name: customerDetails.source,
          is_pennydrop_done: "No",
        });
      }
    } catch (error) {
      // console.log(error);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      navigate(`${route}`, {
        replace: true,
      });
      setShowShimmer(false);
    }
  };

  const dsNameMatch = async () => {
    setShowShimmer(true);
    try {
      const { response } = await sendRequest(
        "/" + customerDetails.source + DS_NAME_MATCH,
        {
          current_stage: currentPageStage,
        }
      );
      if (response.Success) {
        setShowSetUpMandate(true);
      } else {
        if (response.Message === "SUCCESS_REJECTED") {
          setShowRejectNameMatchModal(true);
          updateLead(
            customerDetails.source,
            109,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            109,
            customerDetails.application_form_number
          );
        }
      }
      setShowShimmer(false);
    } catch (error) {
      // console.log(error);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      navigate(`${route}`, {
        replace: true,
      });
      setShowShimmer(false);
    }
  };

  const checkEmandateStatusApiOnLoad = async () => {
    try {
      // console.log("Approved/Rejected");
      setShowShimmer(true);
      const response = await sendRequest(
        "/" + customerDetails.source + EMANDATE_POLLING,
        {
          source: customerDetails.source,
          version: "2.0",
          is_mandate_delay_bank: false,
          check_authorization: false,
        }
      );
      setShowShimmer(false);
      // console.log(response.response);
      // console.log(response.response.Success);
      if (response.response.verficationPending) {
        setModal("");
        setRazorpayVerficationPendingModal(true);
      } else if (response.response.Failed) {
        setEmandateRetry(true);
        setModal("");
      } else if (response.response.Success) {
        /* Successful Response Action */
        if (response.response.Failed) {
          setEmandateIframeModalFlag(false);
          setEmandateRetry(true);
          moengage.track_event("bank_verification_emandate", {
            journey_name: customerDetails.source,
            is_emandate_done: "No",
          });
        }
        if (response.response.Approved) {
          moengage.track_event("bank_verification_emandate", {
            journey_name: customerDetails.source,
            is_emandate_done: "yes",
          });
          /* Emandate Approved */
          // var route = getRouteFromLoanStageService({
          //   source: customerDetails.source,
          //   // stage: customerDetails.stage,
          //   stage: response.STAGE,
          // });
          setCustomerDetails({
            ...customerDetails,
            stage: response.response.STAGE,
          });
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              59,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              59,
              customerDetails.application_form_number
            );
          }
          // console.log("stage: ", response.STAGE);
          // // console.log("route: ", route);
          // navigate(`${route}`, {
          //   replace: true,
          //   state: {
          //     customerDetails: customerDetails,
          //   },
          // });
          /* CRM Stage - E-Mandate Successful */
        }
      } else if (response.response.Success === false) {
        setShowSetUpMandate(true);
      }
    } catch (error) {
      setShowShimmer(false);
    }
  };

  const checkEmandateStatusApi = async () => {
    try {
      // console.log("Approved/Rejected");
      const { response } = await poll(
        async () =>
          await sendRequest("/" + customerDetails.source + EMANDATE_POLLING, {
            source: customerDetails.source,
            version: "2.0",
            is_mandate_delay_bank: false,
            check_authorization: false,
          }),
        ({ response }) =>
          response.Approved || response.Failed || response.verficationPending,
        10000,
        120
      );
      if (response.verficationPending) {
        setModal("");
        setRazorpayVerficationPendingModal(true);
      } else if (response.Failed) {
        setEmandateRetry(true);
        setModal("");
      } else if (response.Success) {
        /* Successful Response Action */
        if (response.Failed) {
          setEmandateIframeModalFlag(false);
          setEmandateRetry(true);
        }
        if (response.Approved) {
          /* Emandate Approved */
          // var route = getRouteFromLoanStageService({
          //   source: customerDetails.source,
          //   // stage: customerDetails.stage,
          //   stage: response.STAGE,
          // });
          setCustomerDetails({
            ...customerDetails,
            stage: response.STAGE,
          });
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              59,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              59,
              customerDetails.application_form_number
            );
          }
          // console.log("stage: ", response.STAGE);
          // // console.log("route: ", route);
          // navigate(`${route}`, {
          //   replace: true,
          //   state: {
          //     customerDetails: customerDetails,
          //   },
          // });
          /* CRM Stage - E-Mandate Successful */
        }
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          72,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          72,
          customerDetails.application_form_number
        );
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      setShowShimmer(false);
      /* Handle unexpected response */
      if (error.code === "ECONNABORTED") {
      } else {
        /* CRM Stage - E-Mandate Check Technical Failure */
        console.error(`Unknown Error: ${error}`);
      }
    }
  };

  const handleProceedClick =async ()=>{
    const payload = {
      income_bank_account_verification: bankAccVerificationConsent,
    }
    const src = customerDetails.source;
    await userConsentStatus(payload , src);
    await insertBankDetails();
  }

  // const [emandateUrl, setEmandateUrl] = useState("https://rzp.io/i/gB93a4K");
  const insertBankDetails = async () => {
    if (!allFieldsValidated()) {
      return;
    }
    // console.log(
    //   customerDetails.Data.account_number,
    //   customerDetails.Data.account_number.length
    // );
    if (
      customerDetails.source === "upsell" ||
      customerDetails.Data.journey_type === "preapproved"
    ) {
      try {
        setButtonDisabledFlag(true);
        setShowShimmer(true);
        const formData = new FormData();
        const requestData = {
          bank_name: bank,
          branch_name: branch,
          ifsc_code: ifsc.toString(),
          account_number: accountNumber.toString(),
          account_holder_name: (
            customerDetails.Data.first_name.trim() +
            " " +
            customerDetails.Data.last_name.trim()
          ).trim(),
          current_stage: customerDetails.stage,
          stage_conditions: {
            isPreapproved: true,
          },
        };
        formData.append("data", encryptedData(requestData));
        // console.log(
        //   "IN_INSERT_BANK_DETAILS: ",
        //   INSERT_BANK_DETAILS,
        //   "\nPayload: ",
        //   requestData
        // );
        try {
          const response = await sendRequest(
            "/" + customerDetails.source + INSERT_BANK_DETAILS,
            formData
          );
          // console.log("INSERT_BANK_DETAILS response: ", response);
          // setShowShimmer(false);
          if (response.response.Success === true) {
              currentPageStage = response.response.STAGE;
              await pennyDropApi();
          } else {
            if (response.response.Message === "Bank account number does not match with udyam") {
              setBankUdyamMismatchModal(true)
            }
          }
          // setShowShimmer(false);
        } catch (error) {
          if (
            error.message === "API call cancelled due to connectivity issue"
          ) {
            setInternetCheck(true);
          } else {
            if (customerDetails.source === "upsell") {
              updateLead(
                customerDetails.source,
                71,
                customerDetails.application_form_number
              );
            } else {
              updateLead(
                customerDetails.source,
                71,
                customerDetails.application_form_number
              );
            }
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "error",
            });
            navigate(`${route}`, {
              replace: true,
            });
            setShowShimmer(false);
            console.error(`Unknown Error: ${error}`);
          }
        }
      } catch (error) {
        if (error.message === "API call cancelled due to connectivity issue") {
          setInternetCheck(true);
        } else {
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              71,
              customerDetails.application_form_number
            );
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "error",
            });
            navigate(`${route}`, {
              replace: true,
            });
          } else {
            updateLead(
              customerDetails.source,
              71,
              customerDetails.application_form_number
            );
          }
        }
        // setShowShimmer(false);
        // console.log(error);
      }
    } else if (customerDetails.source === "epl") {
      let flag = true;
      // console.log(customerDetails?.Data.account_number);
      if (
        customerDetails?.Data.account_number !== undefined &&
        customerDetails?.Data.account_number !== "" &&
        customerDetails?.Data.account_number !== null &&
        customerDetails?.Data.account_number !== "None"
      ) {
        let custInputBankNumberLast4 = accountNumber.slice(-4);
        let custDetailsBankNumberLast4 =
          customerDetails?.Data?.account_number.slice(-4);
        // console.log(
        //   "CUSTOMER DETAILS ACCOUNT NUMBER",
        //   custDetailsBankNumberLast4
        // );
        // console.log("CUSTOMER INPUT ACCOUNT NUMBER", custInputBankNumberLast4);
        for (let i = 0; i < 4; i++) {
          if (
            custDetailsBankNumberLast4[i] !== "X" &&
            custDetailsBankNumberLast4[i] !== "x"
          ) {
            if (custInputBankNumberLast4[i] !== custDetailsBankNumberLast4[i]) {
              flag = false;
              setBankDetailsWrong(true);
              break;
            }
          }
        }
      }

      if (flag) {
        try {
          setButtonDisabledFlag(true);
          setShowShimmer(true);
          const formData = new FormData();
          const requestData = {
            bank_name: bank,
            branch_name: branch,
            ifsc_code: ifsc.toString(),
            account_number: accountNumber.toString(),
            account_holder_name:
              customerDetails.Data.first_name +
              " " +
              customerDetails.Data.last_name,
            current_stage: currentPageStage,
            stage_conditions: {
              isPreapproved: true,
            },
          };
          formData.append("data", encryptedData(requestData));
          try {
            const response = await sendRequest(
              "/" + customerDetails.source + INSERT_BANK_DETAILS,
              formData
            );
            // console.log("INSERT_IPO response: ", response);
            // setShowShimmer(false);
            if (response.response.Success === true) {
              currentPageStage = response.response.STAGE;
              await pennyDropApi();
              // setShowSetUpMandate(true);
            } else {
              if (response.response.Message === "Bank account number does not match with udyam") {
                setBankUdyamMismatchModal(true)
              }
            }
            setShowShimmer(false);
          } catch (error) {
            if (
              error.message === "API call cancelled due to connectivity issue"
            ) {
              setInternetCheck(true);
            } else {
              var route = getRouteFromLoanStageService({
                source: customerDetails.source,
                stage: "error",
              });
              navigate(`${route}`, {
                replace: true,
              });
              setShowShimmer(false);
              console.error(`Unknown Error: ${error}`);
            }
          }
        } catch (error) {
          if (
            error.message === "API call cancelled due to connectivity issue"
          ) {
            setInternetCheck(true);
          } else {
            if (customerDetails.source === "upsell") {
              updateLead(
                customerDetails.source,
                71,
                customerDetails.application_form_number
              );
              var route = getRouteFromLoanStageService({
                source: customerDetails.source,
                stage: "error",
              });
              navigate(`${route}`, {
                replace: true,
              });
            } else {
              updateLead(
                customerDetails.source,
                71,
                customerDetails.application_form_number
              );
            }
          }
          // setShowShimmer(false);
          // console.log(error);
        }
      }
    }
  };

  return (
    <>
      <ProgressBar showProgress={true} currentStep={5} showText={false} />
      <BankUdyamMismatchModal
        isOpen={bankUdyamMismatchModal}
        onClose={() => {
          setBankUdyamMismatchModal(false);
        }}
      />
      <PennyDropModal
        msg={responseMessage}
        isOpen={pennyDropFailed}
        onClose={() => {
          setPennyDropFailed(false);
          setIfsc();
          setShowShimmer(false);
        }}
      />
      <CheckInternetModal
        isOpen={internetCheck}
        onClose={() => {
          setInternetCheck(false);
          setShowShimmer(false);
        }}
      />
      <BankDetailsIncorrect
        isOpen={bankDetailsWrong}
        onClose={() => {
          setBankDetailsWrong(false);
        }}
      />
      <EmandateVerificationPendingModal
        isOpen={razorpayVerficationPendingModal}
        onClose={() => {
          // setRazorpayVerficationPendingModal(false);
          // setShowSetUpMandate(true);
        }}
      />
      <EmandateRetryModal
        isOpen={emandateRetry}
        onClose={() => {
          setShowSetUpMandate(true);
        }}
      />
      <EmandateFailedModal
        isOpen={maxRetryReached}
        onClose={() => {
          setMaxRetryReached(false);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "rejected",
          });
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }}
      />
      <RejectNameMatchModal
        isOpen={showRejectNameMatchModal}
        onClose={() => {
          setShowRejectNameMatchModal(false);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "rejected",
          });
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }}
      />
      <AfterLoginLayoutWrapper>
        {/* <Iframe url={iFrameUrl}
          width="640px"
          height="320px"
          id=""
          className=""
          display={iFrameDisplay}
          position="relative" /> */}
        {/* <Loading
          open={(loading || ['IMPSCHECK', 'EMANDATEINCOMPLETE'].includes(state)) && !showIframe}
        /> */}
        {/* <Modal open={state === 'BANKNOTLISTED'} onClose={() => setState('EDITING')}>
          <BankNotListedModal />
        </Modal>
        <Modal open={state === 'TECHNICAL'} onClose={() => setState(mainState)}>
          <ErrorModal />
        </Modal> */}
        {/* <Modal
          closeOnClickOutside={false}
          showCloseButton={false}
          open={['IMPSINIT', 'IMPSFAIL'].includes(state) && !loading}
        >
          <ImpsInitModal
            retry={state === 'IMPSFAIL'}
            onModify={() => {
              setState('EDITING');
              setMainState('EDITING');
            }}
            onProceed={callImps}
          />
        </Modal> */}
        {/* <Modal
          showCloseButton={false}
          closeOnClickOutside={false}
          open={state === 'EMANDATEINIT' && !loading}
        >
          <AutoDebitModal
            onClick={() => {
              checkBank();
            }}
          />
        </Modal> */}
        {/* <Modal open={emandateNoteModal} showCloseButton={false} closeOnClickOutside={false}>
          <EmandateRegistrationTimeModal onClick={callEmandate} />
        </Modal> */}
        {/* <Modal
					open={showIframe}
					showCloseButton={emandateShowCloseButton}
					closeOnClickOutside={false}
					onClose={() => {
						// history.replace({
						//   pathname: `/loan`,
						//   search: location.search,
						// });
						navigate("/reference", {
							replace: true,
						});
					}}
					id="bd-emandate_iframe-parent"
				>
					<EmandateIframeModal
						url={iFrameUrl}
						id="bd-emandate_iframe"
					/>
				</Modal> */}
        <CSSTransition
          classNames={`bdp-emandate bdp-emandate-animation`}
          in={modal === "EMANDATE_IFRAME"}
          timeout={{ appear: 0, enter: 0, exit: 0 }}
          unmountOnExit
        >
          <Modal
            open={emandateIframeModalFlag}
            showCloseButton={emandate.showIframeCloseButton}
            closeOnClickOutside={false}
            onClose={handleOnCloseEmandateIframeModal}
            id="bdp-emandate-iframe-parent"
          >
            <EmandateIframeModal url={emandate.url} id="bdp-emandate-iframe" />
          </Modal>
        </CSSTransition>

        <ScenarioBasedModal
          id="bd-modal"
          isOpen={showSetUpMandate}
          showCloseButton={false}
          secondButton={
            parseInt(customerDetails?.Data?.cust_accepted_emi) <= 1
          }
          onClose={() => {
            // setNoOffer(false);
            setOpenEmandateIframe(true);
            // setShowSetUpMandate(false);
            // TODO: REMOVE THIS
            // setCustomerDetails({
            //   ...customerDetails,
            //   stage: "REFERENCE_START",
            // });
          }}
          modalIcon="&#10004;"
          // modalMessageHeading="Bank Account Verified!"
          modalMessage="Please set up auto debit to complete your application."
          modalSubmitMessage="E-Nach"
          onModalSubmitbutton2={async () => {
            console.log("UPI for Mobile Application");
            if (sessionStorage.getItem("mobileApplication") !== "TRUE") {
              await callEmandateApi("upi");
            }
          }}
          modalSubmitMessagebutton2 = "UPI mandate"
          style={{ borderRadius: "20px" }}
          onModalSubmit={async () => {
            console.log("Emandate for Mobile Application");
            if (sessionStorage.getItem("mobileApplication") !== "TRUE") {
              await callEmandateApi("e-nach");
            }
            // setNoOffer(false);
            // setOpenEmandateIframe(true);
            // callEmandateApi("e-nach");
            // setShowSetUpMandate(false);
            // TODO: REMOVE THIS
            // setCustomerDetails({
            //   ...customerDetails,
            //   stage: "REFERENCE_START",
            // });
          }}
        />
        <BankDetailsWrapper className="first-child">
          <ShimmerPlaceholder
            visible={showShimmer}
            width="12em"
            marginTop="1em"
          />
          <ShimmerPlaceholder
            visible={showShimmer}
            width="12em"
            marginTop="0.5em"
          />
          <div className="bank-details-form-title">
            <Title
              id="pageTitle"
              className="pageTitle"
              text={`Bank Verification`}
              icon={
                <>
                  <img
                    src={bankDetailsTitleIcon}
                    alt="titleIcon.svg"
                    height="20"
                    width="20"
                  />
                </>
              }
              visible={!showShimmer}
              clickable={false}
            />
            <SubTitle
              id="pageSubTitle"
              className="pageSubTitle"
              text={"Verify your Bank details"}
              visible={!showShimmer}
              clickable={false}
              style={{
                padding: "0px",
              }}
            />
          </div>
          <form className="bank-details-form">
            {customerDetails.Data.journey_type === "preapproved" ||
            customerDetails.source === "upsell" ? (
              <></>
            ) : (
              <>
                <div className="bank-details-form-input bank-name">
                  <ShimmerPlaceholder
                    visible={showShimmer}
                    marginTop="-2.5em"
                  />
                  <FloatingInput
                    value={bank}
                    on_change={(e) => {
                      setBankNameError(false)
                      if (isEnglish(e.target.value)) {
                        setBank(e.target.value)
                      } else {
                        setBankNameError(true)
                      }
                    }}
                    error={bankNameError}
                    error_message="Please enter valid bank name"
                    visible={!showShimmer}
                    // disabled={customerDetails?.source === "upsell"}
                    disabled={true}
                    type={"text"}
                    label={"Bank Name"}
                  />
                </div>
              </>
            )}
            <div className="bank-details-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                value={accountNumber}
                on_change={updateAccountNumber}
                visible={!showShimmer}
                disabled={customerDetails?.source === "upsell"}
                type={"text"}
                label={"Account Number"}
              />
            </div>
            <div className="bank-details-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                value={accountConfirmNumber}
                on_change={updateAccountConfirmNumber}
                visible={!showShimmer}
                disabled={customerDetails?.source === "upsell"}
                type={"text"}
                error_message={"Account number not matched"}
                error={accountNumber !== accountConfirmNumber}
                label={"Confirm Account Number"}
              />
            </div>
            <div className="bank-details-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                value={ifsc}
                on_change={updateIfsc}
                visible={!showShimmer}
                // disabled={customerDetails?.source === "upsell"}
                error_message={"Invalid IFSC"}
                error={ifscError}
                type={"text"}
                label={"IFSC"}
              />
            </div>
            {customerDetails.source === "upsell" ? (
              <>
                <div className="bank-details-form-input bank-name">
                  <ShimmerPlaceholder
                    visible={showShimmer}
                    marginTop="-2.5em"
                  />
                  <FloatingInput
                    value={bank}
                    on_change={(e) => {
                      setBankNameError(false)
                      if (isEnglish(e.target.value)) {
                        setBank(e.target.value)
                      } else {
                        setBankNameError(true)
                      }
                    }}
                    error={bankNameError}
                    error_message="Please enter valid bank name"
                    visible={!showShimmer}
                    // disabled={customerDetails?.source === "upsell"}
                    disabled={true}
                    type={"text"}
                    label={"Bank Name"}
                  />
                </div>
              </>
            ) : (
              <></>
            )}
            {customerDetails.Data.journey_type !== "preapproved" ? (
              <></>
            ) : (
              <>
                <div className="bank-details-form-input bank-name">
                  <ShimmerPlaceholder
                    visible={showShimmer}
                    marginTop="-2.5em"
                  />
                  <FloatingInput
                    value={bank}
                    on_change={(e) => {
                      setBankNameError(false)
                      if (isEnglish(e.target.value)) {
                        setBank(e.target.value)
                      } else {
                        setBankNameError(true)
                      }
                    }}
                    error={bankNameError}
                    error_message="Please enter valid bank name"
                    visible={!showShimmer}
                    // disabled={customerDetails?.source === "upsell"}
                    disabled={true}
                    type={"text"}
                    label={"Bank Name"}
                  />
                </div>
              </>
            )}
            <div className="bank-details-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                value={branch}
                on_change={(e) => {
                  setBranchNameError(false)
                  if (isEnglish(e.target.value)) {
                    setBranch(e.target.value)
                  } else {
                    setBranchNameError(true)
                  }
                }}
                error={branchNameError}
                error_message="Please enter valid branch name"
                visible={!showShimmer}
                // disabled={customerDetails?.source === "upsell"}
                disabled={true}
                type={"text"}
                label={"Branch Name"}
              />
              <div 
              style={{ display: showShimmer ? "none" : "flex" }}
              >
                <CheckField
                  id="basic-ckeckfield"
                  checked={consentCheckbox}
                  label="I hereby confirm to verify my Bank account whereby Rs 1 will be deposited and Bank account name will be matched with KYC Name."
                  style={{
                    fontSize: "1.4rem",
                    marginTop: "28px",
                  }}
                  onClick={updateConsentCheckbox}
                />
              </div>
            </div>
          </form>
          <div className="bottomDiv only-btn">
            {showShimmer ? (
              <ShimmerPlaceholder visible={showShimmer} width="9em" />
            ) : (
              <Button
                id="Btn"
                className="Btn"
                disabled={!allFieldsValidated() || buttonDisabledFlag}
                text={"Proceed"}
                onClick={
                  // insertBankDetails
                  handleProceedClick
                }
              />
            )}
          </div>
        </BankDetailsWrapper>
      </AfterLoginLayoutWrapper>
    </>
  );
};

export default BankDetails;
